import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { getCurrentUser } from 'api/userCredentials';
import { internalUserIdResolved } from 'redux/actions/auth';
import { useAppDispatch, useAppSelector } from 'redux/hooks';

export const useSetInternalUserId = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.auth.accessToken);
  const profileUserId = useAppSelector((state) => state.auth.profile?.userId);
  const auth0UserId = useAppSelector((state) => state.auth.profile?.auth0UserId || state.auth.profile?.userId);

  const { data: currentUser } = useQuery(['currentUser', auth0UserId], ({ signal }) => getCurrentUser(signal), {
    enabled: Boolean(accessToken && auth0UserId),
    staleTime: Infinity,
  });

  useEffect(() => {
    if (currentUser?.userId && auth0UserId && profileUserId !== currentUser.userId) {
      dispatch(internalUserIdResolved(auth0UserId, currentUser.userId));
    }
  }, [auth0UserId, currentUser?.userId, dispatch, profileUserId]);
};
